export default {
  config: Object,
  data: Object,
  isShow: Boolean
}
